import api from "./api";

class AuthenticationService {
  static Login(data) {
    return api.post("/login/login", data);
  }

  static Register(data) {
    return api.post("/login/register", data);
  }
  static UpdateUser(id, data) {
    return api.put(`/login/activate/${id}`, data);
  }

  static DeactivateUser(id) {
    return api.put(`/login/deactivate/${id}`);
  }
  static ActivateUser(id) {
    return api.put(`/login/activate/${id}`);
  }
}

export default AuthenticationService;
